import ninjaApi from 'store/redux/apis/ninja.api';

export const customCostApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['CustomCost'],
  endpoints: (build) => ({
    customCostList: build.query({
      query: (body) => ({
        url: 'custom-cost/list',
        method: 'POST',
        body,
      }),
      providesTags: ['CustomCost'],
    }),

    createCustomCost: build.mutation({
      query: (body) => ({
        url: 'custom-cost/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomCost'],
    }),

    updateCustomCost: build.mutation({
      query: (body) => ({
        url: 'custom-cost/update',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomCost'],
    }),

    deleteCustomCost: build.mutation({
      query: (body) => ({
        url: 'custom-cost/delete',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomCost'],
    }),
  }),
});

export const {
  useCustomCostListQuery,
  useCreateCustomCostMutation,
  useUpdateCustomCostMutation,
  useDeleteCustomCostMutation,
} = customCostApi;
